<template>
    <div>
        <v-separator v-if="tariff && tariff.title" />

        <v-expansion v-if="tariff && tariff.title">
            <div slot="title">
                <div>
                    <v-text type="subheadling">
                        Тариф: <strong>{{ tariff.title }}</strong>
                    </v-text>
                </div>

                <v-text v-if="tariff.daysLeft <= 30" error>
                    Осталось
                    {{ tariff.daysLeft }}
                    {{ declOfNum(tariff.daysLeft, ['день', 'дня', 'дней']) }}
                </v-text>
            </div>

            <v-text>
                Включено с {{ moment(tariff.startDate).format('DD.MM.YYYY') }}<br>
                Осталось {{ tariff.daysLeft }}
                {{ declOfNum(tariff.daysLeft, ['день', 'дня', 'дней']) }}
            </v-text>

            <v-text type="caption" slot="caption">
                Подробнее
            </v-text>
        </v-expansion>

        <v-separator />
    </div>
</template>

<script>
    import moment from 'moment';
    import { numberWithSpaces, declOfNum } from '../../../helpers';

    export default {
        name: 'tariff-details',
        props: {
            tariff: Object,
        },
        methods: {
            numberWithSpaces,
            declOfNum,
            moment,
        }
    }
</script>


// WEBPACK FOOTER //
// TariffDetails.vue?2e177dcd